module.exports = __webpack_public_path__ + "static/media/design-artboards-2.dc336387.png";